import { Route } from 'react-router-dom'
import { Routes } from '../Routes'
import {
  HostDashEdit,
  HostDashShow,
  HostKaraokeDisplay,
  HostKaraokeEdit,
  HostKaraokeManage,
  HostKaraokeShow,
  HostTriviaGame
} from 'containers'

export const HostGameRouter = () => {
  return (
    <Routes>
      <Route path="dash/:slug" element={<HostDashShow />} />
      <Route path="dash/:slug/edit" element={<HostDashEdit />} />
      <Route path="karaoke/:slug" element={<HostKaraokeShow />} />
      <Route path="karaoke/:slug/display" element={<HostKaraokeDisplay />} />
      <Route path="karaoke/:slug/manage" element={<HostKaraokeManage />} />
      <Route path="karaoke/:slug/edit" element={<HostKaraokeEdit />} />
      <Route path="trivia/:id" element={<HostTriviaGame />} />
    </Routes>
  )
}
